import { render, staticRenderFns } from "./EndingMatch.vue?vue&type=template&id=bff3b518&scoped=true"
import script from "./EndingMatch.vue?vue&type=script&lang=js"
export * from "./EndingMatch.vue?vue&type=script&lang=js"
import style0 from "./EndingMatch.vue?vue&type=style&index=0&id=bff3b518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff3b518",
  null
  
)

export default component.exports